module.exports = __webpack_public_path__ + "static/media/dose-reference-levels.f7a6e524.svg";